// extracted by mini-css-extract-plugin
export default {"details":"A6CrV5kgNM","details-code":"-jBmkwOGQJ","detailsCode":"-jBmkwOGQJ","details-button":"_3PF+89zFrM","detailsButton":"_3PF+89zFrM"};